/* eslint-disable import/prefer-default-export */
import { useCallback } from 'react'
import { Id, ToastOptions, toast } from 'react-toastify'

import Toast from './Toast'
import { ToastInputProps } from './lib/types'

export function useToast() {
  const notify = useCallback((input: ToastInputProps, options?: ToastOptions) => {
    const toastId = toast(<Toast {...input} />, { hideProgressBar: true, ...options })
    return toastId
  }, [])

  const close = useCallback((id: Id) => {
    toast.dismiss(id)
  }, [])

  return {
    notify,
    close,
  }
}
